export const REVENUE_SCHEDULE_EXPORT_TYPES = {
  MONTHLY: "MONTHLY",
  LINE_ITEMS: "LINE_ITEMS",
  CUSTOMERS: "CUSTOMERS",
};

export type REVENUE_SCHEDULE_EXPORT_TYPES_TYPE =
  keyof typeof REVENUE_SCHEDULE_EXPORT_TYPES;

export const REVENUE_SCHEDULE_EXPORT_TYPES_DISPLAY = {
  [REVENUE_SCHEDULE_EXPORT_TYPES.MONTHLY]: "Months",
  [REVENUE_SCHEDULE_EXPORT_TYPES.LINE_ITEMS]: "Invoice Items",
  [REVENUE_SCHEDULE_EXPORT_TYPES.CUSTOMERS]: "Customers",
};
